import type { TechniqueEntry } from '../schema';

// review: 18 Aug selectability pass pending clinical review — requires_first re-anchored from the
// logged record to whatever true progress evidence is in the room.
export const sitWithDiscouragement: TechniqueEntry = {
  key: 'sit_with_discouragement',
  version: '0.2',
  name: 'Sit with the discouragement',
  pillar: 'MI',
  serves:
    'Meeting a member arriving discouraged, convinced nothing has changed: being heard has to come before any evidence to the contrary.',
  method: [
    'Open by asking how things have been and let them say it in their own words.',
    'Sit with the discouragement: reflect it back before doing anything else; do not rush to reassure, do not contradict how they feel.',
    'Only once they have been heard, offer to set something real against the feeling: the logged record when it exists (ask before you show anything), or progress they have themselves named, gathered back to them in their own words.',
    'Show the evidence, then let them react to it before interpreting it: the change is real and it is theirs; the job is making it visible, not congratulating them for it.',
    'Finally, connect what the evidence shows to the target they set and to what they said matters to them; where a gap remains, name it plainly and without pressure. If the data shows no clear picture, say so: an unlogged day is not a zero.',
  ],
  never: [
    'Do not lead with the numbers.',
    'Do not reassure or contradict the feeling before it has been heard.',
    'Never invent a pattern the data does not support.',
    'Never congratulate on their behalf; the change stays theirs to see.',
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause: 'Discouragement voiced or strongly signalled.',
    },
    {
      kind: 'conversation',
      clause:
        'Something real to set against it: logged history when it exists, or progress the member has named, in this conversation or recalled from earlier ones, in their own words. The practice works from whatever true evidence is in the room; it never invents progress, and if there is genuinely nothing true to point to, this technique is ineligible: the evidence turn has nothing to stand on, and plain presence (the standing stance) is the answer instead.',
    },
  ],
  doneWhen:
    'The member has felt heard on the discouragement and reacted to their own record in their own words, with any remaining gap named plainly and left without pressure.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source:
    'agents/cab/base/prompt.md ("How this conversation goes" + chart rules); the base doc\'s tools[] callout names it as the show_progress_chart staging example',
};
